 <template>
   <!-- PAGINATION -->
      <div class="row">
         <div class="col-12 my-4 d-flex justify-content-between">
            <div class="align-items-center d-flex">
               <span class="pagination-summary">
                  <b>{{fromResult}}</b>-<b>{{toResult}}</b> di <b>{{pager.totalResults}}</b>
               </span>
            </div>

            <nav class="pagination-wrapper justify-content-center ml-3" aria-label="Navigazione centrata" >
               <ul class="pagination mb-0">
                <!--li class="page-item first-item" v-if="currentPage !== 1">
                    <router-link :to="{ query: { page: 1 }}" class="page-link">First</router-link>
                </li>
                <li class="page-item previous-item"  v-if="currentPage !== 1">
                    <router-link :to="{ query: { page: pager.currentPage - 1 }}" class="page-link">Previous</router-link>
                </li>
                <li v-for="page in pageCount" :key="page" class="page-item">
                    <router-link :to="{ query: { page: page }}" :class="{}" class="page-link">{{page}}</router-link>
                </li>                  
                <li :class="{'disabled':currentPage === pager.totalPages}" class="page-item next-item">
                    <router-link :to="{ query: { page: pager.currentPage + 1 }}" class="page-link"><i class=""></i></router-link>
                </li>
                <li :class="{'disabled':currentPage === pager.totalPages}" class="page-item last-item">
                    <router-link :to="{ query: { page: pager.totalPages }}" class="page-link">Last</router-link>
                </li-->
                  <li class="page-item next-item" v-if="pager.currentPage > 1"  @click="changePage(currentPage)">
                     <span class="page-link"><i class="fa fa-angle-left"></i></span>
                  </li>

                  <li v-for="page in pageCount" :key="page" class="page-item" @click="changePage(page)" :class="{'active' : pager.currentPage == page}" :title="`pagina ${page}`">
                     <span class="page-link">{{page}}</span>
                  </li>                  

                  <li class="page-item next-item" v-if="pager.currentPage < pageCount"  @click="changePage(currentPage+1)">
                     <span class="page-link"><i class="fa fa-angle-right"></i></span>
                  </li>
               </ul>
            </nav>

            <div class="align-items-center d-flex">
               <span>Risultati per pagina</span>
               <b-form-select class="small ml-1" value-field="value" text-field="text" v-model="selected" :options="options" @change="changeLimit"/>
            </div>   
         </div>
      </div>
   <!-- END PAGINATION -->
 </template>
<script>
export default {
   name: "pager",
   props: {
      pager: {
         type: Object,         
      },      
   },   
   data() {
      return {
         selected: 9,
         options: [
            { value: 6, text: '6' },
            { value: 9, text: '9' },
            { value: 12, text: '12' },
            { value: 15, text: '15' },
         ],
         currentPage: this.$props.pager.currentPage
      }
   },
   mounted(){
      //console.log("currentPage:"+this.$props.pager.currentPage);
      //console.log("totalResults:"+this.$props.pager.totalResults);
      //console.log("limit:"+this.$props.pager.limit);
      //console.log('pages:'+this.pageCount);
   },
   computed:{
      fromResult: function(){
         let fromResult = this.$props.pager.limit * (this.$props.pager.currentPage-1) + 1;
         return (this.$props.pager.currentPage > this.pageCount) ? this.$props.pager.limit * (this.pageCount-1) + 1 : fromResult;   
      },
      toResult: function(){
         let toResult = (this.$props.pager.limit * this.$props.pager.currentPage);         
         return this.$props.pager.totalResults > toResult ? toResult : this.$props.pager.totalResults;
      },
      pageCount: function(){
         return Math.ceil(this.$props.pager.totalResults / this.$props.pager.limit);         
      }
   },
   methods:{
      changePage (event) {
         this.$emit('listenChangePage',event);
      }, 
      changeLimit (event) {
         this.$emit('listenLimitChange',event);
      },       
   }
}
</script>
<style>
.pagination .page-item {cursor:pointer;}
.pagination .page-item.active{border:1px solid #005c99;border-radius:3px;color:#005c99;pointer-events:none;}
</style>